import { useEffect } from 'react'
import { Unity, useUnityContext } from 'react-unity-webgl'

import s from './Heatmap3D.module.scss'

import { SceneGET } from 'types/scenes'

import { useAuthContext } from 'contexts/AppAuthContext'
import { useUnityUnloadContext } from 'contexts/UnityUnloadContext'

import { SizeIcon } from 'assets/icons/SizeIcon'

import { CustomButton } from 'components/UI/CustomButton/CustomButton'

const wasmURL =
  process.env.REACT_APP_UNITY_WASM_URL || 'https://metaads.team/web-gl-application/Build/web-gl-application.wasm'
const frameworkURL =
  process.env.REACT_APP_UNITY_FRAMEWORK_URL ||
  'https://metaads.team/web-gl-application/Build/web-gl-application.framework.js'
const dataURL =
  process.env.REACT_APP_UNITY_DATA_URL || 'https://metaads.team/web-gl-application/Build/web-gl-application.data'
const loaderURL =
  process.env.REACT_APP_UNITY_LOADER_URL || 'https://metaads.team/web-gl-application/Build/web-gl-application.loader.js'

interface Props {
  heatmapFor: 'adspace' | 'campaign' | 'scene'
  scene?: SceneGET | null
  sceneValue: number
  id?: string
  scenes: {
    scenes: SceneGET[]
  } | null
  mode: '2d' | '3d'
  disabledLayout: boolean
  setDisabledLayout: (val: boolean | (() => boolean)) => void
}

export const Heatmap3D = (props: Props) => {
  const { heatmapFor, sceneValue, scene, id = '', scenes, mode, disabledLayout, setDisabledLayout } = props

  const {
    authData: { web3token },
  } = useAuthContext()
  const { unloadSetter } = useUnityUnloadContext()

  const { unityProvider, loadingProgression, isLoaded, sendMessage, unload, requestFullscreen } = useUnityContext({
    loaderUrl: loaderURL,
    dataUrl: dataURL,
    frameworkUrl: frameworkURL,
    codeUrl: wasmURL,
    companyName: 'DefaultCompany',
    productName: 'MetaAds3DMetricsAsset',
    productVersion: '0.1',
  })

  useEffect(() => {
    unloadSetter(unload)
  }, [unload])

  useEffect(() => {
    if (!isLoaded) setDisabledLayout(true)
    else setDisabledLayout(false)
  }, [isLoaded])

  useEffect(() => {
    if (isLoaded && mode === '3d' && sceneValue) {
      sendMessage(
        '[Bridge]',
        'ResponseFromHTML',
        JSON.stringify({
          campaign_id: heatmapFor === 'campaign' ? id : -1,
          ad_spot_id: heatmapFor === 'adspace' ? id : -1,
          scene_id: sceneValue,
          precision: 4,
          time_parts: 10,
          model_url:
            heatmapFor === 'scene'
              ? scene?.scene_file
              : scenes?.scenes?.find((scene) => scene.id === sceneValue)?.scene_file,
          token: web3token,
          base_url: process.env.REACT_APP_STATISTICS_API_URL || 'https://metaads.team/',
        })
      )
    }
  }, [isLoaded, web3token, sceneValue, id, scenes?.scenes?.length, mode])

  return (
    <>
      <div>{(loadingProgression * 100).toFixed(2) + '%'}</div>
      <div className={s.heatmapBG}>
        <Unity unityProvider={unityProvider} className={s.unityComponent} />
        <div className={s.btnWrapper}>
          <CustomButton
            variant="secondary"
            className={s.btn}
            onClick={() => requestFullscreen(true)}
            disabled={disabledLayout}
            small
          >
            <SizeIcon className={s.sizeIcon} />
          </CustomButton>
        </div>
      </div>
    </>
  )
}
